import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { auth } from "../firebase/config";
import { signInWithEmailAndPassword } from "firebase/auth";
import { logining } from "../features/userSlice";

export const useLogin = () => {
  const [error, setError] = useState(null);
  const [isCancelled, setIsCancelled] = useState(false);
  const dispatch = useDispatch();

  const login = async (email, password) => {
    setError(null);

    try {
      const res = await signInWithEmailAndPassword(auth, email, password);

      if (!isCancelled) {
        console.log("user logged in:", res.user);

        // Extract only the required serializable fields
        const userData = {
          uid: res.user.uid,
          email: res.user.email,
          displayName: res.user.displayName,
        };

        dispatch(logining(userData));
        setError(null);
      }
    } catch (err) {
      if (!isCancelled) {
        setError(err.message);
      }
    }
  };

  useEffect(() => {
    return () => setIsCancelled(true); // Cleanup on component unmount
  }, []);

  return { error, login };
};
